$(function () {
    var countdown = 6;
    var now = Date.parse(new Date());
    var ready = Date.parse(new Date(now + countdown * 1000)); // * 1000 to get ms

    var interval = setInterval(function () {
        var sec = (ready - Date.parse(new Date())) / 1000;

        $('.popup__timer').text(sec);

        if (sec === 0) {
            clearInterval(interval);
            location.href = 'https://www.emorfiq.com/'
        }

    }, 1000);
})